module.exports = __webpack_public_path__ + "static/material-bread-docs-aa90c7023fb1e9495376607715d37f16.png";